import React from "react";
import contactUsBG from "../images/contact_us_bg.jpg";

import { useForm, ValidationError } from "@formspree/react";

export default function Contact() {
  const [state, handleSubmit] = useForm("xpqjoavj");

  if (state.succeeded) {
    return (
      <section style={styles.section}>
        <div style={styles.bg}></div>
        <div style={styles.card}>
          <h2 style={styles.successTitle}>Message Sent Successfully</h2>
          <p style={styles.successText}>
            We’ll get back to you shortly.
          </p>
        </div>
      </section>
    );
  }

  return (
    <section style={styles.section}>
      <div style={styles.bg}></div>

      <div style={styles.card}>
        <h1 style={styles.title}>Let’s Build Something Powerful</h1>
        <p style={styles.subtitle}>
          Tell us about your project and we’ll show you how to transform it.
        </p>

        <form style={styles.form} onSubmit={handleSubmit}>
          <input
            style={styles.input}
            id="name"
            type="text"
            name="name"
            placeholder="Your Name"
            required
          />

          <input
            style={styles.input}
            id="email"
            type="email"
            name="email"
            placeholder="Your Email"
            required
          />
          <ValidationError prefix="Email" field="email" errors={state.errors} />

          <textarea
            style={styles.textarea}
            id="message"
            name="message"
            placeholder="Your Message"
            rows={5}
            required
          />
          <ValidationError prefix="Message" field="message" errors={state.errors} />

          <button style={styles.button} type="submit" disabled={state.submitting}>
            {state.submitting ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
    </section>
  );
}

const styles = {
  section: {
    position: "relative",
    padding: "160px 20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },

  bg: {
    position: "absolute",
    inset: 0,
        backgroundImage: `url(${contactUsBG})`,
            backgroundSize: "cover",
    backgroundPosition: "center",
    filter: "blur(10px) brightness(0.5)",
    transform: "scale(1.15)",
  },

  card: {
    position: "relative",
    zIndex: 2,
    background: "rgba(255,255,255,0.18)",
    padding: "25px",
    borderRadius: "20px",
    color: "#ffffff",
    width: "100%",
    maxWidth: "600px",
    backdropFilter: "blur(18px)",
    border: "1px solid rgba(255,255,255,0.2)",
    boxShadow: "0 40px 80px rgba(0,0,0,0.6)",
    textAlign: "center",
  },

  title: {
    fontSize: "36px",
    fontWeight: "700",
    marginBottom: "10px",
  },

  subtitle: {
    marginBottom: "40px",
    fontSize: "16px",
    color: "rgba(255,255,255,0.8)",
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },

  input: {
    padding: "16px 20px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.3)",
    background: "rgba(255,255,255,0.3)",
    color: "#ffffff",
    fontSize: "15px",
    outline: "none",
    transition: "0.3s ease",
  },

  textarea: {
    padding: "16px 20px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.3)",
    background: "rgba(255,255,255,0.3)",
    color: "#ffffff",
    fontSize: "15px",
    outline: "none",
    resize: "none",
    transition: "0.3s ease",
  },

  button: {
    marginTop: "10px",
    padding: "16px",
    borderRadius: "12px",
    border: "none",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    background: "linear-gradient(90deg,#2563eb,#3b82f6)",
    color: "#ffffff",
    boxShadow: "0 15px 35px rgba(37,99,235,0.4)",
    transition: "0.3s ease",
  },

  successTitle: {
    fontSize: "28px",
    marginBottom: "10px",
    background: "linear-gradient(90deg,#2563eb,#3b82f6)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },

  successText: {
    color: "rgba(255,255,255,0.8)",
  },
};